/**
 * @generated SignedSource<<8fe361674d7d73802423396d09a46f37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueFormElements_templateElements$data = {
  readonly elements: ReadonlyArray<{
    readonly __typename: "IssueFormElementCheckboxes";
    readonly checkboxOptions: ReadonlyArray<{
      readonly label: string;
      readonly labelHTML: string;
      readonly required: boolean | null | undefined;
    }>;
    readonly descriptionHTML: string | null | undefined;
    readonly itemId: string | null | undefined;
    readonly label: string;
  } | {
    readonly __typename: "IssueFormElementDropdown";
    readonly " $fragmentSpreads": FragmentRefs<"DropdownElement_input">;
  } | {
    readonly __typename: "IssueFormElementInput";
    readonly " $fragmentSpreads": FragmentRefs<"TextInputElement_input">;
  } | {
    readonly __typename: "IssueFormElementMarkdown";
    readonly contentHTML: string;
  } | {
    readonly __typename: "IssueFormElementTextarea";
    readonly descriptionHTML: string | null | undefined;
    readonly itemId: string | null | undefined;
    readonly label: string;
    readonly placeholder: string | null | undefined;
    readonly render: string | null | undefined;
    readonly required: boolean | null | undefined;
    readonly value: string | null | undefined;
  } | {
    readonly __typename: "IssueFormElementUpload";
    readonly " $fragmentSpreads": FragmentRefs<"UploadElement_input">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  }>;
  readonly " $fragmentType": "IssueFormElements_templateElements";
};
export type IssueFormElements_templateElements$key = {
  readonly " $data"?: IssueFormElements_templateElements$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFormElements_templateElements">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueFormElements_templateElements"
};

(node as any).hash = "9567db675f57bceda0e324f059107ed2";

export default node;
